
import { defineComponent, Ref, ref } from "vue";
import LoginFormContainer from "./LoginFormContainer.vue";
import StatusBlock from "./StatusBlock.vue";
import LoadingModal from "./LoadingModal.vue";
import RecaptchaBlock from "./RecaptchaBlock.vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import { States, submitHandler } from "./submit_handler";
import { useConfigStore } from "@/store/config";
import { useUserStore } from "@/store/user";

export default defineComponent({
  components: {
    LoginFormContainer,
    StatusBlock,
    LoadingModal,
    Form,
    Field,
    ErrorMessage,
    RecaptchaBlock,
  },
  setup() {
    const user = useUserStore();
    const config = useConfigStore();
    let states: States = {
      recaptcha: ref(null),
      loadingShow: ref(false),
      errorMessage: ref(""),
      captchaEnabled: config.captcha.validateCaptchaForResendActivation,
    };

    let emailSent = ref("");
    let showResendSuccess = ref(false);
    let email = ref("");

    function resendActivation() {
      submitHandler(
        user.resendActivation({
          email: email.value,
          ...(states.captchaEnabled
            ? {
              captcha: (
                states.recaptcha as Ref<typeof RecaptchaBlock>
              )?.value?.token(),
            }
            : {}),
        }),
        states,
        (response) => {
          //success handler
          if (response?.success) {
            emailSent.value = email.value;
            showResendSuccess.value = true;
          } else {
            states.errorMessage.value = "Resend activation link error";
          }
        }
      );
    }

    return {
      loadingShow: states.loadingShow,
      captchaEnabled: states.captchaEnabled,
      errorMessage: states.errorMessage,
      recaptcha: states.recaptcha,
      emailSent,
      showResendSuccess,
      email,
      resendActivation,
    };
  },
});
